export default __webpack_public_path__ + "static/media/img8.db6ebc34.jpg";